export default __webpack_public_path__ + "static/media/logo-2.be92651f.png";